import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import {
    Box,
    Paper,
    Typography,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Chip,
    IconButton,
    Avatar,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from "@mui/material";

import { rtdb } from "../../services/firebase";
import { ref, onValue, update, remove } from "firebase/database";

import { Link } from "react-router-dom";
import { MdEdit, MdDelete, MdVisibility, MdVisibilityOff } from "react-icons/md";

import { FaInfoCircle } from "react-icons/fa";

export default function Products() {
    const [produtos, setProdutos] = useState([]);

    const [estoqueOpen, setEstoqueOpen] = useState(false);
    const [variacoesSelecionadas, setVariacoesSelecionadas] = useState([]);
    const [produtoSelecionado, setProdutoSelecionado] = useState(null);

    const [confirmOpen, setConfirmOpen] = useState(false);
    const [produtoParaToggle, setProdutoParaToggle] = useState(null);

    const [deleteOpen, setDeleteOpen] = useState(false);
    const [produtoParaExcluir, setProdutoParaExcluir] = useState(null);
    const [deleteLoading, setDeleteLoading] = useState(false);

    useEffect(() => {
        const productsRef = ref(rtdb, "products");

        const unsubscribe = onValue(productsRef, (snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.val();

                const lista = Object.values(data);
                setProdutos(lista);
            } else {
                setProdutos([]);
            }
        });

        return () => unsubscribe();
    }, []);

    function abrirEstoque(produto) {
        setProdutoSelecionado(produto);
        setVariacoesSelecionadas(produto.variacoes || []);
        setEstoqueOpen(true);
    }

    function abrirConfirmacao(produto) {
        setProdutoParaToggle(produto);
        setConfirmOpen(true);
    }

    function fecharConfirmacaoStatus() {
        setConfirmOpen(false);
        setProdutoParaToggle(null);
    }

    async function toggleStatusProduto() {
        if (!produtoParaToggle) return;

        const novoStatus =
            produtoParaToggle.status === "active" ? "inactive" : "active";

        try {
            const produtoRef = ref(rtdb, `products/${produtoParaToggle.id}`);

            await update(produtoRef, {
                status: novoStatus
            });

            fecharConfirmacaoStatus();
        } catch (error) {
            console.error("Erro ao atualizar status:", error);
            toast.error("Erro ao atualizar status do produto.");
        }
    }

    function abrirConfirmacaoExclusao(produto) {
        setProdutoParaExcluir(produto);
        setDeleteOpen(true);
    }

    function fecharConfirmacaoExclusao() {
        if (deleteLoading) return;
        setDeleteOpen(false);
        setProdutoParaExcluir(null);
    }

    async function excluirProduto() {
        if (!produtoParaExcluir?.id) return;

        try {
            setDeleteLoading(true);

            const produtoRef = ref(rtdb, `products/${produtoParaExcluir.id}`);
            await remove(produtoRef);

            setDeleteOpen(false);
            setProdutoParaExcluir(null);
        } catch (error) {
            console.error("Erro ao excluir produto:", error);
            toast.error("Erro ao excluir produto.");
        } finally {
            setDeleteLoading(false);
        }
    }

    return (
        <Box sx={{ p: { xs: 2, sm: 3, md: 4 }, width: "100%", maxWidth: "100%", overflow: "auto" }}>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    justifyContent: "space-between",
                    alignItems: { xs: "stretch", sm: "center" },
                    gap: 2,
                    mb: 3,
                }}
            >
                <Typography variant="h4" sx={{ fontWeight: 700, fontSize: { xs: "1.35rem", md: "1.5rem" } }}>
                    Produtos
                </Typography>
                <Button variant="contained" component={Link} to="/admin/produtos/novo" sx={{ alignSelf: { xs: "stretch", sm: "center" } }}>
                    Criar Produto
                </Button>
            </Box>

            <Paper sx={{ p: { xs: 1, sm: 2 }, borderRadius: 3, overflow: "hidden" }}>
                <TableContainer sx={{ overflowX: "auto" }}>
                    <Table sx={{ minWidth: 640 }}>
                        <TableHead>
                            <TableRow>
                                <TableCell>ID</TableCell>
                                <TableCell>Produto</TableCell>
                                <TableCell>Descrição</TableCell>
                                <TableCell>Preço</TableCell>
                                <TableCell>Promoção</TableCell>
                                <TableCell align="center">Ações</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {produtos.map((p) => (
                                <TableRow key={p.id} hover>
                                    <TableCell>{p.id}</TableCell>

                                    <TableCell>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                                            <Avatar
                                                src={p.imagens?.[0]}
                                                variant="rounded"
                                                sx={{ width: 48, height: 48 }}
                                            />
                                            <Typography sx={{ fontWeight: 600 }}>
                                                {p.nome}
                                            </Typography>
                                        </Box>
                                    </TableCell>

                                    <TableCell>
                                        {p.descricao
                                            ? `${p.descricao.substring(0, 40)}...`
                                            : "-"}
                                    </TableCell>

                                    <TableCell>{p.precos?.normal || "-"}</TableCell>

                                    <TableCell>
                                        {p.precos?.isPromo ? (
                                            <Chip label="Sim" color="success" size="small" />
                                        ) : (
                                            <Chip label="Não" size="small" />
                                        )}
                                    </TableCell>

                                    <TableCell align="center">
                                        <IconButton
                                            color="primary"
                                            onClick={() => abrirEstoque(p)}
                                            title="Ver Estoque"
                                        >
                                            <FaInfoCircle size={20} />
                                        </IconButton>

                                        <IconButton
                                            color="primary"
                                            component={Link}
                                            to={`/admin/editar-produto/${p.id}`}
                                        >
                                            <MdEdit size={20} />
                                        </IconButton>

                                        <IconButton
                                            onClick={() => abrirConfirmacao(p)}
                                            title={
                                                p.status === "active"
                                                    ? "Desativar produto do site"
                                                    : "Ativar produto no site"
                                            }
                                            sx={{
                                                color:
                                                    p.status === "inactive"
                                                        ? "error.main"
                                                        : "var(--azul)"
                                            }}
                                        >
                                            {p.status === "active" ? (
                                                <MdVisibility size={20} />
                                            ) : (
                                                <MdVisibilityOff size={20} />
                                            )}
                                        </IconButton>

                                        <IconButton
                                            color="error"
                                            onClick={() => abrirConfirmacaoExclusao(p)}
                                            title="Excluir produto"
                                        >
                                            <MdDelete size={20} />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>

            <Dialog
                open={estoqueOpen}
                onClose={() => setEstoqueOpen(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>
                    Estoque — {produtoSelecionado?.nome}
                </DialogTitle>

                <DialogContent>
                    {variacoesSelecionadas.length === 0 ? (
                        <Typography>Nenhuma variação cadastrada.</Typography>
                    ) : (
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Variação</TableCell>
                                    <TableCell>Estoque</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {variacoesSelecionadas.map((v, i) => (
                                    <TableRow key={i}>
                                        <TableCell>{v.nome}</TableCell>
                                        <TableCell>{v.quantidade}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    )}
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setEstoqueOpen(false)}>Fechar</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={confirmOpen}
                onClose={fecharConfirmacaoStatus}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle>
                    {produtoParaToggle?.status === "active"
                        ? "Desativar produto"
                        : "Ativar produto"}
                </DialogTitle>

                <DialogContent>
                    <Typography>
                        Tem certeza que deseja{" "}
                        <strong>
                            {produtoParaToggle?.status === "active"
                                ? "desativar"
                                : "ativar"}
                        </strong>{" "}
                        o produto <strong>{produtoParaToggle?.nome}</strong> no site?
                    </Typography>
                </DialogContent>

                <DialogActions>
                    <Button onClick={fecharConfirmacaoStatus}>
                        Não
                    </Button>

                    <Button
                        color="error"
                        variant="contained"
                        onClick={toggleStatusProduto}
                    >
                        Sim, confirmar
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={deleteOpen}
                onClose={fecharConfirmacaoExclusao}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle>Excluir produto</DialogTitle>

                <DialogContent>
                    <Typography>
                        Tem certeza que deseja excluir permanentemente o produto{" "}
                        <strong>{produtoParaExcluir?.nome}</strong>?
                    </Typography>

                    <Typography sx={{ mt: 1, color: "error.main", fontSize: 14 }}>
                        Essa ação não poderá ser desfeita.
                    </Typography>
                </DialogContent>

                <DialogActions>
                    <Button
                        onClick={fecharConfirmacaoExclusao}
                        disabled={deleteLoading}
                    >
                        Cancelar
                    </Button>

                    <Button
                        color="error"
                        variant="contained"
                        onClick={excluirProduto}
                        disabled={deleteLoading}
                    >
                        {deleteLoading ? "Excluindo..." : "Sim, excluir"}
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}